import React from 'react';
import paginationFirstDisabled from '../assets/images/pagination-first-disabled.svg';

export default () => {
  return <img src={paginationFirstDisabled} alt="First Page Disabled" />;
};
